import { render } from "./GrossToNet.vue?vue&type=template&id=232fb8e8&scoped=true&ts=true"
import script from "./GrossToNet.vue?vue&type=script&lang=ts"
export * from "./GrossToNet.vue?vue&type=script&lang=ts"

import "./GrossToNet.vue?vue&type=style&index=0&id=232fb8e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Desktop\\Projekte\\paga-ime\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232fb8e8"]])

export default __exports__